<template>
  <v-menu
    v-if="availableWidgets"
    id="metrics-dropdown"
    v-model="showMenu"
    :close-on-content-click="false"
    location="bottom"
    transition="scale-transition"
  >
    <template #activator="{ props }">
      <v-btn
        id="add-chart-button"
        variant="flat"
        color="cyan-dark"
        class="mx-0 pl-4"
        v-bind="props"
        :prepend-icon="CONSTANTS.ICONS_MDI.ICON_PLUS"
      >
        {{ labels.BUTTONS.ADD_CHART }}
      </v-btn>
    </template>

    <v-card id="metrics-card" class="mx-auto" width="400">
      <v-list shaped>
        <v-list-subheader>Available Metrics</v-list-subheader>
        <v-list-group
          v-for="(currentMetricsMenuPoint, i) in availableWidgets.widgets"
          :key="i"
          multiple
          data-test-id="available-metric"
        >
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              :title="currentMetricsMenuPoint.name"
              :prepend-icon="currentMetricsMenuPoint.icon"
              class="spaced-list-item"
            ></v-list-item>
            <v-divider />
          </template>
          <v-list-item
            v-for="(currentMetric, j) in currentMetricsMenuPoint.charts"
            :key="j"
            data-test-id="widget-metric"
            :value="currentMetric"
            color="primary"
            @click="addChart(currentMetric)"
          >
            <v-list-item-title>
              {{ currentMetric.defaultTitle }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ currentMetric.defaultSubTitle }}
            </v-list-item-subtitle>
          </v-list-item>
        </v-list-group>
      </v-list>
      <v-btn color="primary" class="custom-metric-button" @click="addCustomMetric">
        Add Custom Metric
      </v-btn>
    </v-card>
  </v-menu>

  <custom-metric-modal
    :is-opened="openDialog"
    :custom-metric="undefined"
    :is-view-mode="isViewMode"
    @close-dialog="openDialog = false"
    @disable-view-mode="isViewMode = false"
  />
</template>

<script lang="ts" setup>
  import labels from '@/translations/labels.json'
  import { AvailableWidgets } from '@/models/dashboard.model'
  import CONSTANTS from '@/constants/Config.constants'
  import { computed, ref } from 'vue'
  import { useDashboardStore } from '@/stores/dashboardStore'
  import { Chart } from '@/models/chart.model'
  import CustomMetricModal from '@/pages/project/CustomMetricModal.vue'
  import { useRouter } from 'vue-router'

  const router = useRouter()
  const dashboardStore = useDashboardStore()

  const availableWidgets = computed((): AvailableWidgets | undefined => {
    return dashboardStore.availableWidgets
  })

  const openDialog = ref(false)
  const isViewMode = ref(false)
  const showMenu = ref(false)

  async function addChart(chartToCreate: Chart): Promise<void> {
    dashboardStore.addWidgetFromChart(chartToCreate)
  }

  function addCustomMetric(): void {
    /* openDialog.value = true
    isViewMode.value = false */
    router.push({
      name: labels.CUSTOM_METRIC.CUSTOM_METRIC,
      params: { customMetricId: -1 },
    })
  }
</script>

<style lang="scss" scoped>
  .menupoint_icon {
    padding: 10px;
  }

  .custom-metric-button {
    width: calc(100% - 48px);
    margin: 0 24px;
  }

  .mx-auto {
    padding-bottom: 20px;
  }

  .no-custom-metrics-text {
    padding-inline-start: calc(var(--indent-padding) + 48px) !important;
  }
</style>

<style lang="scss">
  /* Targeting the specific list item icon spacing */
  .spaced-list-item .v-list-item__content {
    padding-left: 20px;
  }
</style>
